import { render, staticRenderFns } from "./LearningFeedback.vue?vue&type=template&id=0e39f2dd"
import script from "./LearningFeedback.vue?vue&type=script&lang=js"
export * from "./LearningFeedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports